const assetCount = count => `${count} asset${count === 1 ? '' : 's'}`;

const getBulkOperationCounts = (bulkJob, operation) => {
    const counts = bulkJob?.operation_counts?.[operation] || {};

    return {
        succeeded: counts.succeeded_count || 0,
        skipped: counts.skipped_count || 0,
        failed: counts.failed_count || 0
    };
};

const buildBulkOperationMessage = (
    bulkJob,
    operation,
    {succeededLabel, skippedLabel}
) => {
    const counts = getBulkOperationCounts(bulkJob, operation);
    const parts = [];

    if(counts.succeeded) parts.push(`${assetCount(counts.succeeded)} ${succeededLabel}`);
    if(counts.skipped) parts.push(`${assetCount(counts.skipped)} ${skippedLabel}`);
    if(counts.failed) parts.push(`${assetCount(counts.failed)} failed`);
    if(bulkJob?.error) parts.push(bulkJob.error);
    if(!parts.length) parts.push('No assets were changed');

    return {
        content: parts
            .map(part => /[.!?]$/.test(part) ? part : `${part}.`)
            .join(' '),
        type: bulkJob?.error || (counts.failed && !counts.succeeded && !counts.skipped)
            ? 'error'
            : counts.failed ? 'warning' : 'success',
        counts
    };
};

export {buildBulkOperationMessage, getBulkOperationCounts};
